// extracted by mini-css-extract-plugin
export default {"background":"DashboardPurchase_background__TjiQq","font":"DashboardPurchase_font__eT-TP","title":"DashboardPurchase_title__8FOpk","titleFund":"DashboardPurchase_titleFund__jil21"};